import ContentItem from '@reperio-news/core.components/blocks/ContentItem/View.svelte';
import ContentList from '@reperio-news/core.components/blocks/ContentList/View.svelte';
import Title from '@reperio-news/core.components/blocks/Title/View.svelte';
import EditorContent from '@reperio-news/core.components/blocks/EditorContent/View.svelte';
import RawHTML from '@reperio-news/core.components/blocks/RawHTML/View.svelte';
import Image from '@reperio-news/core.components/blocks/Image/View.svelte';
import TopMenu from './TopMenu/View.svelte';
import Footer from './Footer/View.svelte';
import AdPosition from '@reperio-news/core.components/blocks/AdPosition/View.svelte';
import ArticleHeader from './ArticleHeader/View.svelte';
import Calendar from './Calendar/View.svelte';

// components that will be available in page building process for this domain
export default {
	ContentItem,
	ContentList,
	Title,
	Image,
	RawHTML,
	EditorContent,
	TopMenu,
	Footer,
	AdPosition,
	ArticleHeader,
	Calendar
}

import * as ContentItemViews from './ContentItem';
import * as BlockContainerViews from './BlockContainer/Default.svelte';
import * as TitleViews from './Title';
import * as AdPositionView from './AdPosition/Default.svelte';
import * as ContentListViews from './ContentList';

// this are global components (reperio.core) that have customized views for this domain
export const DOMAIN_VIEWS = {
	ContentItem: {...ContentItemViews},
	BlockContainer: {...BlockContainerViews},
	Title: {...TitleViews},
	AdPosition: {default: AdPositionView},
	ContentList: {...ContentListViews}
}

